<template>
    <div>
        <div class="banner">
            <div class="headerReplacementCalendarInfo"></div>
            <div class="banner-text">
                <b>{{ $t('calendarInfo.title') }}</b>
                <div class="breadcrumb">
                    <span>
                        <router-link to="/" class="pe-auto">{{ $t('calendarInfo.home') }}</router-link>
                    </span>
                    <span class="separator"></span>
                    <span><b>{{ $t('calendarInfo.breadcrumb') }}</b></span>
                </div>
            </div>
        </div>

        <div class="container d-flex align-items-center justify-content-center mb-5">
            <div class="card card-calendar" style="width: 30rem;">
                <div class="card-body">
                    <i class="fa-solid fa-calendar"></i>
                    <small class="text-secondary">
                        {{ formatDate(latestEvent.publish_date_calendar_investor) }}
                    </small>
                    <p class="mt-3 mb-0">{{ latestEvent.title_calendar_investor }}</p>
                    <p>{{ latestEvent.detail_ad_calendar_investor }}</p>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row g-3 justify-content-end align-items-end mt-3 mb-5">
                <div class="col-md-auto">
                    <label class="col-form-label">{{ $t('calendarInfo.labelYear') }}</label>
                </div>
                <div class="col-md-2">
                    <select v-model="selectedYear" id="yearSelect" class="form-select" aria-label="Year selection">
                        <option value="2025">2025</option>
                        <option value="2024">2024</option>
                        <option value="2023">2023</option>
                        <option value="2022">2022</option>
                        <option value="2021">2021</option>
                    </select>
                </div>
            </div>

            <div class="table-responsive">
                <table class="table mb-5">
                    <thead>
                        <tr class="table-secondary text-center">
                            <th scope="col" class="col-2">
                                <b>{{ $t('calendarInfo.table.date') }}</b>
                            </th>
                            <th scope="col" class="col-5">
                                <b>{{ $t('calendarInfo.table.event') }}</b>
                            </th>
                            <th scope="col" class="col-5">
                                <b>{{ $t('calendarInfo.table.detail') }}</b>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="isLoading">
                            <td colspan="3" class="text-center">
                                <div class="spinner-grow custom-spinner" role="status">
                                    <span class="visually-hidden">{{ $t('calendarInfo.loading') }}</span>
                                </div>
                            </td>
                        </tr>
                        <tr v-for="(item, index) in filteredList" :key="index">
                            <td class="text-center">{{ formatDate(item.publish_date_calendar_investor) }}</td>
                            <td class="text-center">{{ item.title_calendar_investor }}</td>
                            <td class="text-center">{{ item.detail_ad_calendar_investor }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
  

<script>
import BasicInfoTabMenu from '@/components/BasicInfoTabMenu.vue';
import store from "@/store";
import { GET_CALENDAR_INVESTOR } from "../../store/actions.type";
import dayjs from 'dayjs';

export default {
    name: 'Info',
    components: {
        BasicInfoTabMenu,
    },
    data() {
        return {
            list: [],
            isLoading: false,
            selectedYear: '2025',  // Default year
        };
    },
    async created() {
        this.isLoading = true;
        await this.init();
        this.isLoading = false;
    },
    watch: {
        '$i18n.locale'(newLang) {
            this.init();
        }
    },
    methods: {
        async init() {
            const lang = this.$i18n.locale || 'th';
            this.list = await store.dispatch(GET_CALENDAR_INVESTOR, lang);
        },
        formatDate(dateString) {
            return dayjs(dateString).format('DD MMMM YYYY');
        },
    },
    computed: {
        // Filter the list based on the selected year
        filteredList() {
            return this.list.filter(item => {
                const eventYear = dayjs(item.publish_date_calendar_investor).year();
                return eventYear.toString() === this.selectedYear;
            });
        },

        // Computed property to get the latest event
        latestEvent() {
            if (this.filteredList.length === 0) return {};
            // Sort the filtered list in descending order by date and return the first item
            return this.filteredList.sort((a, b) => dayjs(b.publish_date_calendar_investor).unix() - dayjs(a.publish_date_calendar_investor).unix())[0];
        }
    },
};
</script>

<style scoped>
.fa-calendar:before {
    content: "\f133";
    color: #E87D2E;
}

.card-calendar {
    box-shadow: 0px 4px 20px 0px #00000014;
    border-left: 5px solid #E87D2E;
    border-top: none;
    border-right: none;
    border-bottom: none;
}

th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.table th {
    font-size: 0.85rem;
    font-weight: normal;
    padding: 8px;
}

/* .custom-spinner {
    width: 1rem;
    height: 1rem;
} */
</style>
